import { AnalysisResult } from "@/redux/feature/videoDashboard/videoDashboardType";

interface TechnicalProps {
  technical: AnalysisResult["technical_analysis"];
}

const Technical: React.FC<TechnicalProps> = ({ technical }) => {
  const items = [
    {
      label: "Physical Settings",
      value: technical.physical_setting?.replace(/_/g, " ") || "N/A",
    },
    {
      label: "Visual Clarity",
      value: technical.visual_clarity_score
        ? `${technical.visual_clarity_score}/5`
        : "N/A",
    },
    {
      label: "Ad Format",
      value: technical.ad_format?.replace(/_/g, " ") || "N/A",
    },
    {
      label: "Pacing",
      value: technical.pacing_median_seconds
        ? `${technical.pacing_median_seconds}s median`
        : "N/A",
    },
    {
      label: "Eye Contact",
      value:
        technical.eye_contact_percent !== undefined
          ? `${technical.eye_contact_percent}%`
          : "N/A",
    },
    {
      label: "Text Overlay",
      value: technical.early_text_overlay || "N/A",
    },
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-y-3 gap-x-4 p-2 rounded-lg border border-[#000] border-opacity-30">
        {items.map((item) => (
          <div key={item.label} className="space-y-1">
            <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] font-medium font-grotesk">
              {item.label}
            </h4>
            <p className="text-[#0D0D0D] text-[11px] leading-[120%] font-medium">
              {item.value}
            </p>
          </div>
        ))}
      </div>
      <div className="space-y-1 p-2 rounded-lg border border-[#000] border-opacity-30">
        <h4 className="text-[#0D0D0D80] text-[13px] leading-[120%] tracking-[0%] font-medium font-grotesk">
          Artist Notes
        </h4>
        <p className="text-[#0D0D0D] text-[11px] leading-[120%] tracking-[0%]">
          {technical.storyline || "N/A"}
        </p>
      </div>
    </div>
  );
};

export default Technical;
